'use client'

import { useEffect, useRef } from 'react'

/** Run a callback function only once on mount */
export function useOnMount(callback: (...args: any) => any) {
  const mounted = useRef(false)

  useEffect(() => {
    if (!callback || mounted.current) return
    mounted.current = true
    callback()
  }, [callback])
}
